/**
 * Application constants
 */

// API endpoints
export const ENDPOINTS = {
  TOP_FINDINGS: 'top-finding',
  CONTESTS: 'contest',
  BOUNTIES: 'bounty',
  AUDITS: 'audit',
  CONTRIBUTIONS: 'contribution'
};

// Severity levels and their display order
export const SEVERITY_LEVELS = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  INFORMATIONAL: 'informational',
  INSIGHT: 'insight'
};

// Award levels
export const AWARD_LEVELS = {
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
  PARTICIPANT: 'participant'
};

// Table headers
export const TABLE_HEADERS = {
  TOP_FINDINGS: ['Title', 'Severity'],
  CONTESTS: ['Contest', 'Type', 'Award', 'Platform', 'Date', 'Report', 'My Findings'],
  BUG_BOUNTY: ['Project', 'Severity', 'Date', 'Report'],
  AUDITS: ['Project', 'Type', 'Date', 'Report'],
  CONTRIBUTIONS: ['Title', 'Date', 'Link']
};

// Findings legend
export const FINDINGS_LEGEND = 'C = Critical, H = High, M = Medium, L = Low, I = Informational';

// Default data limits
export const DATA_LIMITS = {
  TOP_FINDINGS: 5,
  RECENT_ITEMS: 10
};
